/** @format */

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { MenuCursos } from "../Components/Cursos/MenuCursos";

export const CursosDisponibles = () => {
  const [cursosDisponibles, setCursosDisponibles] = useState([]);
  const [nivelesMasAltos, setNivelesMasAltos] = useState({});
  const [nivelesCalculados, setNivelesCalculados] = useState(false);
  const [seleccion, setSeleccion] = useState("Grupos Idiomas disponibles");
  const user = useSelector((state) => state.user.id);
  const finalizados = useSelector((state) => state.finalizados);
  const path = useSelector((state) => state.sitePath);
  console.log("Finalizados", finalizados);
  useEffect(() => {
    if (finalizados) {
      encontrarNivelesMasAltos();
    }
  }, [finalizados]);

  useEffect(() => {
    if (nivelesCalculados) {
      proximosNiveles();
    }
  }, [nivelesCalculados, nivelesMasAltos]);

  const encontrarNivelesMasAltos = () => {
    const niveles = {};
    const cursos = Object.values(finalizados);

    cursos.forEach((curso) => {
      if (curso.id_tipo == 4) {
        const idioma = curso.nombre[0];
        const nivel = curso.id_nivel;

        if (!(idioma in niveles) || niveles[idioma] < nivel) {
          niveles[idioma] = nivel;
        }
      }
    });
    setNivelesMasAltos(niveles);
    setNivelesCalculados(true);
  };

  const proximosNiveles = () => {
    const nivelesMasAltosArray = Object.entries(nivelesMasAltos).map(
      ([idioma, nivel]) => ({
        idioma,
        nivel,
      })
    );

    const obj = {
      data: nivelesMasAltosArray,
      user: user,
    };

    axios
      .post(path + "/inscripcion.php", obj)
      .then((res) => {
        if (res.data === "No hay grupos") {
          setCursosDisponibles([]);
        } else {
          let data = res.data[0];
          setCursosDisponibles(data);
        }
      })
      .catch((error) => {});
  };

  // Maneja el cambio de selección
  const manejarCambioSeleccion = (event) => {
    const nuevaSeleccion = event.target.value;
    setSeleccion(nuevaSeleccion);
    // console.log(nuevaSeleccion);

    axios
      .get(path + "/ofertaAcademica/grupoAcademico.php", {
        params: { seccion: nuevaSeleccion },
      })
      .then((res) => {
        if (res.data.length > 0) {
          let data = res.data;
          console.log(res.data);
          setCursosDisponibles(data);
        } else {
          setCursosDisponibles([]);
        }
      })
      .catch((error) => {});
  };

  return (
    <div>
      <div className=''>
        <select
          className='mx-2'
          onChange={manejarCambioSeleccion}
        >
          <option value={"disponibles"}>Grupos Idiomas disponibles</option>
          <option value={"diplomados"}>Diplomados</option>
          <option value={"cursos"}>Cursos</option>
          <option value={"talleres"}>Talleres</option>
        </select>
      </div>

      {/* Renderiza el menú solo si la selección es "Grupos Idiomas disponibles" */}
      {seleccion !== "Grupos Idiomas disponibles" && (
        <MenuCursos
          isActive='disponibles'
          cursosDisponibles={cursosDisponibles}
        />
      )}
    </div>
  );
};
